import type { LoaderFunctionArgs } from 'react-router-dom';
import type { QueryClient } from '@tanstack/react-query';
import { isNil } from 'remeda';

import { type User } from '@/features/auth/types';
import { routerQueryLoaderFn } from '@/shared/utils/query-client.utils';
import { couponQuery } from '@/features/billing/api/get-coupon.query';
import type { LoaderStore } from '@/stores';
import { getProductsQuery } from '@/features/billing/api/get-products.query';
import { redirectCancellingCustomers } from '@/shared/utils/redirect-cancelling-customers.util';

export const pricingRouteLoader =
  (queryClient: QueryClient, globalLoaderActions: LoaderStore['actions']) =>
  async ({ request }: LoaderFunctionArgs) => {
    globalLoaderActions.show();

    const user = queryClient.getQueryData<User>(['auth-user']);
    const isRedirecting = redirectCancellingCustomers(user);

    const url = new URL(request.url);
    const couponCodeUrlParam = url.searchParams.get('coupon');

    const data = await Promise.all([
      routerQueryLoaderFn(queryClient, getProductsQuery()),

      isNil(couponCodeUrlParam)
        ? undefined
        : routerQueryLoaderFn(
            queryClient,
            couponQuery([{ couponCode: couponCodeUrlParam }]),
          ),
    ]);

    if (!isRedirecting) {
      globalLoaderActions.hide();
    }

    return data;
  };
